import { WhatsAppIcon } from '../../../components/icons/CustomIcons';
import { Button } from '../../../components/ui/Button';
import { Card } from '../../../components/ui/Card';
import { useWhatsappCoexistence } from './hooks/useWhatsappCoexistence';

export default function WhatsappCoexistenceConnections() {
  const {
    connection,
    isAdmin,
    isLoading,
    isConnecting,
    isDisconnecting,
    isSyncing,
    handleConnect,
    handleDisconnect,
    handleRemove,
    handleSync,
  } = useWhatsappCoexistence();

  const connected = connection?.status === 'Conectado';

  return (
    <Card className="p-4 md:p-6">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <WhatsAppIcon className="h-9 w-9 sm:h-10 sm:w-10" />
          <div>
            <h3 className="text-section-title text-default">WhatsApp Business</h3>
            <p className="text-xs text-muted">Coexistência com a Meta · 1 número por organização</p>
          </div>
        </div>
        {connected ? (
          <span className="rounded-full bg-success/10 px-3 py-1 text-2xs font-medium text-success">
            Conectado
          </span>
        ) : (
          <span className="rounded-full bg-surface-subtle px-3 py-1 text-2xs font-medium text-muted">
            Não conectado
          </span>
        )}
      </div>

      {isLoading ? (
        <p className="text-sm text-muted">Carregando...</p>
      ) : connection ? (
        <div className="space-y-3">
          <p className="text-sm text-default">
            <strong>{connection.name}</strong>
            {connection.displayNumber ? ` · ${connection.displayNumber}` : ''}
          </p>
          <p className="text-xs text-muted">
            {connection.coexistence
              ? 'O app WhatsApp Business continua no celular. Esta conta usa um número só. Para trocar, remova e conecte outro.'
              : 'Esta conta usa um número só. Para trocar, remova e conecte outro.'}
          </p>
          {connection.syncWarning ? (
            <p className="text-xs text-warning">{connection.syncWarning}</p>
          ) : null}
          {isAdmin ? (
            <div className="flex flex-col gap-2 sm:flex-row">
              {connected ? (
                <Button type="button" variant="outline" onClick={() => void handleDisconnect()} disabled={isDisconnecting}>
                  {isDisconnecting ? 'Desconectando...' : 'Desconectar'}
                </Button>
              ) : (
                <Button type="button" onClick={() => void handleConnect()} disabled={isConnecting}>
                  {isConnecting ? 'Conectando...' : 'Conectar de novo'}
                </Button>
              )}
              {connected && connection.canRetrySync ? (
                <Button type="button" variant="outline" onClick={() => void handleSync()} disabled={isSyncing}>
                  {isSyncing ? 'Sincronizando...' : 'Sincronizar de novo'}
                </Button>
              ) : null}
              <Button type="button" variant="outline" onClick={() => void handleRemove()}>
                Remover
              </Button>
            </div>
          ) : (
            <p className="text-xs text-warning">Apenas administradores podem alterar esta conexão.</p>
          )}
        </div>
      ) : (
        <div className="space-y-3">
          <p className="text-sm text-muted">
            O cliente conecta o WhatsApp Business que já está no celular. As conversas entram aqui e o app continua no telefone.
          </p>
          {!isAdmin && (
            <p className="text-xs text-warning">Apenas administradores podem conectar.</p>
          )}
          <Button type="button" onClick={() => void handleConnect()} disabled={isConnecting || !isAdmin}>
            {isConnecting ? 'Conectando...' : 'Conectar WhatsApp Business'}
          </Button>
        </div>
      )}
    </Card>
  );
}
